import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PessoaTipoPipeModule } from '../../../pessoa/tipo';
import { PessoaContatoModule } from '../../contato';
import { OrigemPipeModule } from '../../../common/origens/pipes';
import { CanalMidiaSocialPipeModule } from '../../../common/canal-midia-social/pipes';
import { ClienteFormInfoComponent } from './cliente-form-info.component';
import { SimplesNacionalFormModule } from '../../../common/simples-nacional';
import { MEIFormModule } from '../../../common/mei';
import { CNAEsViewModule } from '../../../cnaes/components/cnaes-view';
import { CNAEPipeModule } from '../../../cnaes/pipes';
import { CapitalSocialFormControlTextModule } from '../../../common/capital-social/form-control-text';
import { SocioViewModule } from '../../../common/socios/view';
import { IdentificadorMatrizFilialModule } from '../../../common/identificador-matriz-filial';
import { NaturezaJuridicaFormControlModule } from '../../../common/natureza-juridica/components/form-control';
import { PorteEmpresaFormControlModule } from '../../../common/porte-empresa/components/form-control';

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoPipeModule,
        OrigemPipeModule,
        CanalMidiaSocialPipeModule,
        PessoaContatoModule,
        SimplesNacionalFormModule,
        MEIFormModule,
        CNAEsViewModule,
        CNAEPipeModule,
        CapitalSocialFormControlTextModule,
        SocioViewModule,
        IdentificadorMatrizFilialModule,
        NaturezaJuridicaFormControlModule,
        PorteEmpresaFormControlModule
    ],
    declarations: [
        ClienteFormInfoComponent
    ],
    exports: [
        ClienteFormInfoComponent
    ]
})
export class ClienteFormInfoModule { }
